export const exeptionRoom = undefined; //Если нет exeptionRoom, то она строго undefined
